import React from 'react'
import { format, SqlLanguage } from 'sql-formatter'
import Raven from 'raven-js'

interface Props {
    code: string
    visibleLines: number
    driver: string
    maxLength?: number
    type?: string
}

class CodeCover extends React.Component<Props> {
    public static defaultProps = {
        visibleLines: 5,
        driver: 'mysql',
    }

    public state = {
        open: false,
        copiedToClipboard: false,
        error: false,
    }

    public toggle = () => {
        this.setState({ open: !this.state.open })
    }

    public copyToClipboard = code => {
        navigator.clipboard
            .writeText(code)
            .then(() =>
                // Set state to show the copied icon for 6 seconds (like the Prismjs copy button)
                this.setState({ copiedToClipboard: true }, () => setTimeout(() => this.setState({ copiedToClipboard: false }), 6000)),
            )
            .catch(error => {
                // Set state to show the error icon for 6 seconds (like the Prismjs copy button)
                this.setState({ error: true }, () => setTimeout(() => this.setState({ error: false }), 6000))
                console.error('Could not copy text: ', error)
            })
    }

    public clipboardApiAvailable = () => {
        return navigator.clipboard && typeof navigator.clipboard.writeText !== 'undefined'
    }

    public render() {
        const styles = this.state.open ? '' : 'code-light--collapsed'

        const driverToLanguage = (driver: string): SqlLanguage => {
            const mapper = {
                mysql: 'mysql',
                sqlite: 'sqlite',
                pgsql: 'postgresql',
            }

            return mapper[driver]
        }

        const formattedQuery = code => {
            let query = code.replace(/\[\.\.\]/g, `/* placeholder */`)

            const language = driverToLanguage(this.props.driver)

            try {
                query = format(query, { language })
            } catch (error) {
                // fail silently and keep SQL unformatted
                Raven.captureException(error)
            }

            query = query.replace(/\/\* placeholder \*\//g, '[..]')

            return query
        }

        const code = this.props.type === 'sql' ? formattedQuery(this.props.code) : this.props.code

        const lines = code.split(/\r\n|\r|\n/).length

        const setIcon = () => {
            if (this.state.copiedToClipboard) {
                return 'fa-check'
            } else if (this.state.error) {
                return 'fa-ban'
            } else {
                return 'fa-clipboard'
            }
        }

        return (
            <pre className={'code-light ' + styles}>
                {this.clipboardApiAvailable() && (
                    <button
                        title="copy code to clipboard"
                        className="pull-right btn btn-unstyled"
                        style={{ marginLeft: '0.5em' }}
                        onClick={() => this.copyToClipboard(code)}
                    >
                        <i className={`fa ${setIcon()}`} />
                    </button>
                )}
                {lines > this.props.visibleLines && (
                    <button title="fold in/out" className="pull-right btn btn-unstyled" onClick={this.toggle}>
                        <i className={this.state.open ? 'fa fa-arrow-up' : 'fa fa-arrow-down'} />
                    </button>
                )}
                <code>{code}</code>
            </pre>
        )
    }
}

export default CodeCover
